import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {extractErrorMessage} from "../../common/common";

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  form: FormGroup = new FormGroup({
    username: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  });

  error?: string;

  errorMessages: { [key: number]: string } = {
    400: "Please enter your IAM username and password.",
    403: "User not authorized.",
    500: "Something went wrong logging you in."
  };

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit(): void {
    this.authService.isLogged().subscribe({
      next: (res: any) => {
        if (res) {
          this.router.navigate(['/home']);
        }
      },
      error: (_) => {
        console.log('User not logged in');
      }
    });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.error = "Please enter your IAM username and password.";
      return;
    }

    const username = this.form.value.username;
    const password = this.form.value.password;

    this.authService.login(username, password).subscribe({
      next: () => {
        this.error = undefined;
        this.router.navigate(['/home']);
      },
      error: (err) => {
        if (err.status && this.errorMessages[err.status]) {
          this.error = this.errorMessages[err.status];
        } else {
          this.error = extractErrorMessage(err, "An error occurred during login.");
        }
        console.error('Login error:', err);
      }
    });
  }
}
